export const Countries = [
  {
    name: 'Afghanistan',
    en: 'Afghanistan',
    pl: 'Afganistan',
    ru: 'Афганистан',
    uk: 'Афганістан',
    dial_code: '+93',
    emoji: '🇦🇫',
    code: 'AF',
  },
  {
    name: 'Aland Islands',
    en: 'Aland Islands',
    pl: 'Wyspy Alandzkie',
    ru: 'Аландские острова',
    uk: 'Аландські острови',
    dial_code: '+358',
    emoji: '🇦🇽',
    code: 'AX',
  },
  {
    name: 'Albania',
    en: 'Albania',
    pl: 'Albania',
    ru: 'Албания',
    uk: 'Албанія',
    dial_code: '+355',
    emoji: '🇦🇱',
    code: 'AL',
  },
  {
    name: 'Algeria',
    en: 'Algeria',
    pl: 'Algieria',
    ru: 'Алжир',
    uk: 'Алжир',
    dial_code: '+213',
    emoji: '🇩🇿',
    code: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    en: 'American Samoa',
    pl: 'Samoa Amerykańskie',
    ru: 'Американское Самоа',
    uk: 'Американське Самоа',
    dial_code: '+1684',
    emoji: '🇦🇸',
    code: 'AS',
  },
  {
    name: 'Andorra',
    en: 'Andorra',
    pl: 'Andora',
    ru: 'Андорра',
    uk: 'Андорра',
    dial_code: '+376',
    emoji: '🇦🇩',
    code: 'AD',
  },
  {
    name: 'Angola',
    en: 'Angola',
    pl: 'Angola',
    ru: 'Ангола',
    uk: 'Ангола',
    dial_code: '+244',
    emoji: '🇦🇴',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    en: 'Anguilla',
    pl: 'Anguilla',
    ru: 'Ангилья',
    uk: 'Ангілья',
    dial_code: '+1264',
    emoji: '🇦🇮',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    en: 'Antarctica',
    pl: 'Antarktyda',
    ru: 'Антарктида',
    uk: 'Антарктида',
    dial_code: '+672',
    emoji: '🇦🇶',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    en: 'Antigua and Barbuda',
    pl: 'Antigua i Barbuda',
    ru: 'Антигуа и Барбуда',
    uk: 'Антигуа і Барбуда',
    dial_code: '+1268',
    emoji: '🇦🇬',
    code: 'AG',
  },
  {
    name: 'Argentina',
    en: 'Argentina',
    pl: 'Argentyna',
    ru: 'Аргентина',
    uk: 'Аргентина',
    dial_code: '+54',
    emoji: '🇦🇷',
    code: 'AR',
  },
  {
    name: 'Armenia',
    en: 'Armenia',
    pl: 'Armenia',
    ru: 'Армения',
    uk: 'Вірменія',
    dial_code: '+374',
    emoji: '🇦🇲',
    code: 'AM',
  },
  {
    name: 'Aruba',
    en: 'Aruba',
    pl: 'Aruba',
    ru: 'Аруба',
    uk: 'Аруба',
    dial_code: '+297',
    emoji: '🇦🇼',
    code: 'AW',
  },
  {
    name: 'Australia',
    en: 'Australia',
    pl: 'Australia',
    ru: 'Австралия',
    uk: 'Австралія',
    dial_code: '+61',
    emoji: '🇦🇺',
    code: 'AU',
  },
  {
    name: 'Austria',
    en: 'Austria',
    pl: 'Austria',
    ru: 'Австрия',
    uk: 'Австрія',
    dial_code: '+43',
    emoji: '🇦🇹',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    en: 'Azerbaijan',
    pl: 'Azerbejdżan',
    ru: 'Азербайджан',
    uk: 'Азербайджан',
    dial_code: '+994',
    emoji: '🇦🇿',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    en: 'Bahamas',
    pl: 'Bahamy',
    ru: 'Багамские острова',
    uk: 'Багамські острови',
    dial_code: '+1242',
    emoji: '🇧🇸',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    en: 'Bahrain',
    pl: 'Bahrajn',
    ru: 'Бахрейн',
    uk: 'Бахрейн',
    dial_code: '+973',
    emoji: '🇧🇭',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    en: 'Bangladesh',
    pl: 'Bangladesz',
    ru: 'Бангладеш',
    uk: 'Бангладеш',
    dial_code: '+880',
    emoji: '🇧🇩',
    code: 'BD',
  },
  {
    name: 'Barbados',
    en: 'Barbados',
    pl: 'Barbados',
    ru: 'Барбадос',
    uk: 'Барбадос',
    dial_code: '+1246',
    emoji: '🇧🇧',
    code: 'BB',
  },
  {
    name: 'Belarus',
    en: 'Belarus',
    pl: 'Białoruś',
    ru: 'Беларусь',
    uk: 'Білорусь',
    dial_code: '+375',
    emoji: '🇧🇾',
    code: 'BY',
  },
  {
    name: 'Belgium',
    en: 'Belgium',
    pl: 'Belgia',
    ru: 'Бельгия',
    uk: 'Бельгія',
    dial_code: '+32',
    emoji: '🇧🇪',
    code: 'BE',
  },
  {
    name: 'Belize',
    en: 'Belize',
    pl: 'Belize',
    ru: 'Белиз',
    uk: 'Беліз',
    dial_code: '+501',
    emoji: '🇧🇿',
    code: 'BZ',
  },
  {
    name: 'Benin',
    en: 'Benin',
    pl: 'Benin',
    ru: 'Бенин',
    uk: 'Бенін',
    dial_code: '+229',
    emoji: '🇧🇯',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    en: 'Bermuda',
    pl: 'Bermudy',
    ru: 'Бермуды',
    uk: 'Бермуди',
    dial_code: '+1441',
    emoji: '🇧🇲',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    en: 'Bhutan',
    pl: 'Bhutan',
    ru: 'Бутан',
    uk: 'Бутан',
    dial_code: '+975',
    emoji: '🇧🇹',
    code: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    en: 'Bolivia',
    pl: 'Boliwia',
    ru: 'Боливия',
    uk: 'Болівія',
    dial_code: '+591',
    emoji: '🇧🇴',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    en: 'Bosnia and Herzegovina',
    pl: 'Bośnia i Hercegowina',
    ru: 'Босния и Герцеговина',
    uk: 'Боснія і Герцеговина',
    dial_code: '+387',
    emoji: '🇧🇦',
    code: 'BA',
  },
  {
    name: 'Botswana',
    en: 'Botswana',
    pl: 'Botswana',
    ru: 'Ботсвана',
    uk: 'Ботсвана',
    dial_code: '+267',
    emoji: '🇧🇼',
    code: 'BW',
  },
  {
    name: 'Brazil',
    en: 'Brazil',
    pl: 'Brazylia',
    ru: 'Бразилия',
    uk: 'Бразилія',
    dial_code: '+55',
    emoji: '🇧🇷',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    en: 'British Indian Ocean Territory',
    pl: 'Brytyjskie Terytorium Oceanu Indyjskiego',
    ru: 'Британская территория в Индийском океане',
    uk: 'Британська територія в Індійському океані',
    dial_code: '+246',
    emoji: '🇮🇴',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    en: 'Brunei Darussalam',
    pl: 'Brunei Darussalam',
    ru: 'Бруней-Даруссалам',
    uk: 'Бруней-Даруссалам',
    dial_code: '+673',
    emoji: '🇧🇳',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    en: 'Bulgaria',
    pl: 'Bułgaria',
    ru: 'Болгария',
    uk: 'Болгарія',
    dial_code: '+359',
    emoji: '🇧🇬',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    en: 'Burkina Faso',
    pl: 'Burkina Faso',
    ru: 'Буркина-Фасо',
    uk: 'Буркіна-Фасо',
    dial_code: '+226',
    emoji: '🇧🇫',
    code: 'BF',
  },
  {
    name: 'Burundi',
    en: 'Burundi',
    pl: 'Burundi',
    ru: 'Бурунди',
    uk: 'Бурунді',
    dial_code: '+257',
    emoji: '🇧🇮',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    en: 'Cambodia',
    pl: 'Kambodża',
    ru: 'Камбоджа',
    uk: 'Камбоджа',
    dial_code: '+855',
    emoji: '🇰🇭',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    en: 'Cameroon',
    pl: 'Kamerun',
    ru: 'Камерун',
    uk: 'Камерун',
    dial_code: '+237',
    emoji: '🇨🇲',
    code: 'CM',
  },
  {
    name: 'Canada',
    en: 'Canada',
    pl: 'Kanada',
    ru: 'Канада',
    uk: 'Канада',
    dial_code: '+1',
    emoji: '🇨🇦',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    en: 'Cape Verde',
    pl: 'Republika Zielonego Przylądka',
    ru: 'Кабо-Верде',
    uk: 'Кабо-Верде',
    dial_code: '+238',
    emoji: '🇨🇻',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    en: 'Cayman Islands',
    pl: 'Kajmany',
    ru: 'Каймановы острова',
    uk: 'Кайманові острови',
    dial_code: '+345',
    emoji: '🇰🇾',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    en: 'Central African Republic',
    pl: 'Republika Środkowoafrykańska',
    ru: 'Центральноафриканская Республика',
    uk: 'Центральноафриканська Республіка',
    dial_code: '+236',
    emoji: '🇨🇫',
    code: 'CF',
  },
  {
    name: 'Chad',
    en: 'Chad',
    pl: 'Czad',
    ru: 'Чад',
    uk: 'Чад',
    dial_code: '+235',
    emoji: '🇹🇩',
    code: 'TD',
  },
  {
    name: 'Chile',
    en: 'Chile',
    pl: 'Chile',
    ru: 'Чили',
    uk: 'Чилі',
    dial_code: '+56',
    emoji: '🇨🇱',
    code: 'CL',
  },
  {
    name: 'China',
    en: 'China',
    pl: 'Chiny',
    ru: 'Китай',
    uk: 'Китай',
    dial_code: '+86',
    emoji: '🇨🇳',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    en: 'Christmas Island',
    pl: 'Wyspa Bożego Narodzenia',
    ru: 'Остров Рождества',
    uk: 'Острів Різдва',
    dial_code: '+61',
    emoji: '🇨🇽',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    en: 'Cocos (Keeling) Islands',
    pl: 'Wyspy Kokosowe (Keelinga)',
    ru: 'Кокосовые острова (Килинг)',
    uk: 'Кокосові острови (Кілінг)',
    dial_code: '+61',
    emoji: '🇨🇨',
    code: 'CC',
  },
  {
    name: 'Colombia',
    en: 'Colombia',
    pl: 'Kolumbia',
    ru: 'Колумбия',
    uk: 'Колумбія',
    dial_code: '+57',
    emoji: '🇨🇴',
    code: 'CO',
  },
  {
    name: 'Comoros',
    en: 'Comoros',
    pl: 'Komory',
    ru: 'Коморы',
    uk: 'Комори',
    dial_code: '+269',
    emoji: '🇰🇲',
    code: 'KM',
  },
  {
    name: 'Congo',
    en: 'Congo',
    pl: 'Kongo',
    ru: 'Конго',
    uk: 'Конго',
    dial_code: '+242',
    emoji: '🇨🇬',
    code: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    en: 'Democratic Republic of the Congo',
    pl: 'Demokratyczna Republika Konga',
    ru: 'Демократическая Республика Конго',
    uk: 'Демократична Республіка Конго',
    dial_code: '+243',
    emoji: '🇨🇩',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    en: 'Cook Islands',
    pl: 'Wyspy Cooka',
    ru: 'Острова Кука',
    uk: 'Острови Кука',
    dial_code: '+682',
    emoji: '🇨🇰',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    en: 'Costa Rica',
    pl: 'Kostaryka',
    ru: 'Коста-Рика',
    uk: 'Коста-Рика',
    dial_code: '+506',
    emoji: '🇨🇷',
    code: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    en: "Cote d'Ivoire",
    pl: 'Wybrzeże Kości Słoniowej',
    ru: "Кот-д'Ивуар",
    uk: "Кот-д'Івуар",
    dial_code: '+225',
    emoji: '🇨🇮',
    code: 'CI',
  },
  {
    name: 'Croatia',
    en: 'Croatia',
    pl: 'Chorwacja',
    ru: 'Хорватия',
    uk: 'Хорватія',
    dial_code: '+385',
    emoji: '🇭🇷',
    code: 'HR',
  },
  {
    name: 'Cuba',
    en: 'Cuba',
    pl: 'Kuba',
    ru: 'Куба',
    uk: 'Куба',
    dial_code: '+53',
    emoji: '🇨🇺',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    en: 'Cyprus',
    pl: 'Cypr',
    ru: 'Кипр',
    uk: 'Кіпр',
    dial_code: '+357',
    emoji: '🇨🇾',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    en: 'Czech Republic',
    pl: 'Czechy',
    ru: 'Чехия',
    uk: 'Чехія',
    dial_code: '+420',
    emoji: '🇨🇿',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    en: 'Denmark',
    pl: 'Dania',
    ru: 'Дания',
    uk: 'Данія',
    dial_code: '+45',
    emoji: '🇩🇰',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    en: 'Djibouti',
    pl: 'Dżibuti',
    ru: 'Джибути',
    uk: 'Джибуті',
    dial_code: '+253',
    emoji: '🇩🇯',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    en: 'Dominica',
    pl: 'Dominika',
    ru: 'Доминика',
    uk: 'Домініка',
    dial_code: '+1767',
    emoji: '🇩🇲',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    en: 'Dominican Republic',
    pl: 'Dominikana',
    ru: 'Доминиканская Республика',
    uk: 'Домініканська Республіка',
    dial_code: '+1849',
    emoji: '🇩🇴',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    en: 'Ecuador',
    pl: 'Ekwador',
    ru: 'Эквадор',
    uk: 'Еквадор',
    dial_code: '+593',
    emoji: '🇪🇨',
    code: 'EC',
  },
  {
    name: 'Egypt',
    en: 'Egypt',
    pl: 'Egipt',
    ru: 'Египет',
    uk: 'Єгипет',
    dial_code: '+20',
    emoji: '🇪🇬',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    en: 'El Salvador',
    pl: 'Salwador',
    ru: 'Сальвадор',
    uk: 'Сальвадор',
    dial_code: '+503',
    emoji: '🇸🇻',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    en: 'Equatorial Guinea',
    pl: 'Gwinea Równikowa',
    ru: 'Экваториальная Гвинея',
    uk: 'Екваторіальна Гвінея',
    dial_code: '+240',
    emoji: '🇬🇶',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    en: 'Eritrea',
    pl: 'Erytrea',
    ru: 'Эритрея',
    uk: 'Еритрея',
    dial_code: '+291',
    emoji: '🇪🇷',
    code: 'ER',
  },
  {
    name: 'Estonia',
    en: 'Estonia',
    pl: 'Estonia',
    ru: 'Эстония',
    uk: 'Естонія',
    dial_code: '+372',
    emoji: '🇪🇪',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    en: 'Ethiopia',
    pl: 'Etiopia',
    ru: 'Эфиопия',
    uk: 'Ефіопія',
    dial_code: '+251',
    emoji: '🇪🇹',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    en: 'Falkland Islands (Malvinas)',
    pl: 'Falklandy (Malwiny)',
    ru: 'Фолклендские острова (Мальвины)',
    uk: 'Фолклендські острови (Мальвіни)',
    dial_code: '+500',
    emoji: '🇫🇰',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    en: 'Faroe Islands',
    pl: 'Wyspy Owcze',
    ru: 'Фарерские острова',
    uk: 'Фарерські острови',
    dial_code: '+298',
    emoji: '🇫🇴',
    code: 'FO',
  },
  {
    name: 'Fiji',
    en: 'Fiji',
    pl: 'Fidżi',
    ru: 'Фиджи',
    uk: 'Фіджі',
    dial_code: '+679',
    emoji: '🇫🇯',
    code: 'FJ',
  },
  {
    name: 'Finland',
    en: 'Finland',
    pl: 'Finlandia',
    ru: 'Финляндия',
    uk: 'Фінляндія',
    dial_code: '+358',
    emoji: '🇫🇮',
    code: 'FI',
  },
  {
    name: 'France',
    en: 'France',
    pl: 'Francja',
    ru: 'Франция',
    uk: 'Франція',
    dial_code: '+33',
    emoji: '🇫🇷',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    en: 'French Guiana',
    pl: 'Gujana Francuska',
    ru: 'Французская Гвиана',
    uk: 'Французька Гвіана',
    dial_code: '+594',
    emoji: '🇬🇫',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    en: 'French Polynesia',
    pl: 'Polinezja Francuska',
    ru: 'Французская Полинезия',
    uk: 'Французька Полінезія',
    dial_code: '+689',
    emoji: '🇵🇫',
    code: 'PF',
  },
  {
    name: 'Gabon',
    en: 'Gabon',
    pl: 'Gabon',
    ru: 'Габон',
    uk: 'Габон',
    dial_code: '+241',
    emoji: '🇬🇦',
    code: 'GA',
  },
  {
    name: 'Gambia',
    en: 'Gambia',
    pl: 'Gambia',
    ru: 'Гамбия',
    uk: 'Гамбія',
    dial_code: '+220',
    emoji: '🇬🇲',
    code: 'GM',
  },
  {
    name: 'Georgia',
    en: 'Georgia',
    pl: 'Gruzja',
    ru: 'Грузия',
    uk: 'Грузія',
    dial_code: '+995',
    emoji: '🇬🇪',
    code: 'GE',
  },
  {
    name: 'Germany',
    en: 'Germany',
    pl: 'Niemcy',
    ru: 'Германия',
    uk: 'Німеччина',
    dial_code: '+49',
    emoji: '🇩🇪',
    code: 'DE',
  },
  {
    name: 'Ghana',
    en: 'Ghana',
    pl: 'Ghana',
    ru: 'Гана',
    uk: 'Гана',
    dial_code: '+233',
    emoji: '🇬🇭',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    en: 'Gibraltar',
    pl: 'Gibraltar',
    ru: 'Гибралтар',
    uk: 'Гібралтар',
    dial_code: '+350',
    emoji: '🇬🇮',
    code: 'GI',
  },
  {
    name: 'Greece',
    en: 'Greece',
    pl: 'Grecja',
    ru: 'Греция',
    uk: 'Греція',
    dial_code: '+30',
    emoji: '🇬🇷',
    code: 'GR',
  },
  {
    name: 'Greenland',
    en: 'Greenland',
    pl: 'Grenlandia',
    ru: 'Гренландия',
    uk: 'Гренландія',
    dial_code: '+299',
    emoji: '🇬🇱',
    code: 'GL',
  },
  {
    name: 'Grenada',
    en: 'Grenada',
    pl: 'Grenada',
    ru: 'Гренада',
    uk: 'Гренада',
    dial_code: '+1473',
    emoji: '🇬🇩',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    en: 'Guadeloupe',
    pl: 'Gwadelupa',
    ru: 'Гваделупа',
    uk: 'Гваделупа',
    dial_code: '+590',
    emoji: '🇬🇵',
    code: 'GP',
  },
  {
    name: 'Guam',
    en: 'Guam',
    pl: 'Guam',
    ru: 'Гуам',
    uk: 'Гуам',
    dial_code: '+1671',
    emoji: '🇬🇺',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    en: 'Guatemala',
    pl: 'Gwatemala',
    ru: 'Гватемала',
    uk: 'Гватемала',
    dial_code: '+502',
    emoji: '🇬🇹',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    en: 'Guernsey',
    pl: 'Guernsey',
    ru: 'Гернси',
    uk: 'Гернсі',
    dial_code: '+44',
    emoji: '🇬🇬',
    code: 'GG',
  },
  {
    name: 'Guinea',
    en: 'Guinea',
    pl: 'Gwinea',
    ru: 'Гвинея',
    uk: 'Гвінея',
    dial_code: '+224',
    emoji: '🇬🇳',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    en: 'Guinea-Bissau',
    pl: 'Gwinea-Bissau',
    ru: 'Гвинея-Бисау',
    uk: 'Гвінея-Бісау',
    dial_code: '+245',
    emoji: '🇬🇼',
    code: 'GW',
  },
  {
    name: 'Guyana',
    en: 'Guyana',
    pl: 'Gujana',
    ru: 'Гайана',
    uk: 'Гайана',
    dial_code: '+595',
    emoji: '🇬🇾',
    code: 'GY',
  },
  {
    name: 'Haiti',
    en: 'Haiti',
    pl: 'Haiti',
    ru: 'Гаити',
    uk: 'Гаїті',
    dial_code: '+509',
    emoji: '🇭🇹',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    en: 'Holy See (Vatican City State)',
    pl: 'Watykan',
    ru: 'Святой Престол (Ватикан)',
    uk: 'Святий Престол (Ватикан)',
    dial_code: '+379',
    emoji: '🇻🇦',
    code: 'VA',
  },
  {
    name: 'Honduras',
    en: 'Honduras',
    pl: 'Honduras',
    ru: 'Гондурас',
    uk: 'Гондурас',
    dial_code: '+504',
    emoji: '🇭🇳',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    en: 'Hong Kong',
    pl: 'Hongkong',
    ru: 'Гонконг',
    uk: 'Гонконг',
    dial_code: '+852',
    emoji: '🇭🇰',
    code: 'HK',
  },
  {
    name: 'Hungary',
    en: 'Hungary',
    pl: 'Węgry',
    ru: 'Венгрия',
    uk: 'Угорщина',
    dial_code: '+36',
    emoji: '🇭🇺',
    code: 'HU',
  },
  {
    name: 'Iceland',
    en: 'Iceland',
    pl: 'Islandia',
    ru: 'Исландия',
    uk: 'Ісландія',
    dial_code: '+354',
    emoji: '🇮🇸',
    code: 'IS',
  },
  {
    name: 'India',
    en: 'India',
    pl: 'Indie',
    ru: 'Индия',
    uk: 'Індія',
    dial_code: '+91',
    emoji: '🇮🇳',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    en: 'Indonesia',
    pl: 'Indonezja',
    ru: 'Индонезия',
    uk: 'Індонезія',
    dial_code: '+62',
    emoji: '🇮🇩',
    code: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    en: 'Iran',
    pl: 'Iran',
    ru: 'Иран',
    uk: 'Іран',
    dial_code: '+98',
    emoji: '🇮🇷',
    code: 'IR',
  },
  {
    name: 'Iraq',
    en: 'Iraq',
    pl: 'Irak',
    ru: 'Ирак',
    uk: 'Ірак',
    dial_code: '+964',
    emoji: '🇮🇷',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    en: 'Ireland',
    pl: 'Irlandia',
    ru: 'Ирландия',
    uk: 'Ірландія',
    dial_code: '+353',
    emoji: '🇮🇪',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    en: 'Isle of Man',
    pl: 'Wyspa Man',
    ru: 'Остров Мэн',
    uk: 'Острів Мен',
    dial_code: '+44',
    emoji: '🇮🇲',
    code: 'IM',
  },
  {
    name: 'Israel',
    en: 'Israel',
    pl: 'Izrael',
    ru: 'Израиль',
    uk: 'Ізраїль',
    dial_code: '+972',
    emoji: '🇮🇱',
    code: 'IL',
  },
  {
    name: 'Italy',
    en: 'Italy',
    pl: 'Włochy',
    ru: 'Италия',
    uk: 'Італія',
    dial_code: '+39',
    emoji: '🇮🇹',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    en: 'Jamaica',
    pl: 'Jamaika',
    ru: 'Ямайка',
    uk: 'Ямайка',
    dial_code: '+1876',
    emoji: '🇯🇲',
    code: 'JM',
  },
  {
    name: 'Japan',
    en: 'Japan',
    pl: 'Japonia',
    ru: 'Япония',
    uk: 'Японія',
    dial_code: '+81',
    emoji: '🇯🇵',
    code: 'JP',
  },
  {
    name: 'Jersey',
    en: 'Jersey',
    pl: 'Jersey',
    ru: 'Джерси',
    uk: 'Джерсі',
    dial_code: '+44',
    emoji: '🇯🇪',
    code: 'JE',
  },
  {
    name: 'Jordan',
    en: 'Jordan',
    pl: 'Jordania',
    ru: 'Иордания',
    uk: 'Йорданія',
    dial_code: '+962',
    emoji: '🇯🇴',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    en: 'Kazakhstan',
    pl: 'Kazachstan',
    ru: 'Казахстан',
    uk: 'Казахстан',
    dial_code: '+77',
    emoji: '🇰🇿',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    en: 'Kenya',
    pl: 'Kenia',
    ru: 'Кения',
    uk: 'Кенія',
    dial_code: '+254',
    emoji: '🇰🇪',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    en: 'Kiribati',
    pl: 'Kiribati',
    ru: 'Кирибати',
    uk: 'Кірибаті',
    dial_code: '+686',
    emoji: '🇰🇮',
    code: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    en: 'North Korea',
    pl: 'Korea Północna',
    ru: 'КНДР (Северная Корея)',
    uk: 'ПНДК (Північна Корея)',
    dial_code: '+850',
    emoji: '🇰🇵',
    code: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    en: 'South Korea',
    pl: 'Korea Południowa',
    ru: 'Южная Корея',
    uk: 'Південна Корея',
    dial_code: '+82',
    emoji: '🇰🇷',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    en: 'Kuwait',
    pl: 'Kuwejt',
    ru: 'Кувейт',
    uk: 'Кувейт',
    dial_code: '+965',
    emoji: '🇰🇼',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    en: 'Kyrgyzstan',
    pl: 'Kirgistan',
    ru: 'Кыргызстан',
    uk: 'Киргизстан',
    dial_code: '+996',
    emoji: '🇰🇬',
    code: 'KG',
  },
  {
    name: 'Laos',
    en: 'Laos',
    pl: 'Laos',
    ru: 'Лаос',
    uk: 'Лаос',
    dial_code: '+856',
    emoji: '🇱🇦',
    code: 'LA',
  },
  {
    name: 'Latvia',
    en: 'Latvia',
    pl: 'Łotwa',
    ru: 'Латвия',
    uk: 'Латвія',
    dial_code: '+371',
    emoji: '🇱🇻',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    en: 'Lebanon',
    pl: 'Liban',
    ru: 'Ливан',
    uk: 'Ліван',
    dial_code: '+961',
    emoji: '🇱🇧',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    en: 'Lesotho',
    pl: 'Lesotho',
    ru: 'Лесото',
    uk: 'Лесото',
    dial_code: '+266',
    emoji: '🇱🇸',
    code: 'LS',
  },
  {
    name: 'Liberia',
    en: 'Liberia',
    pl: 'Liberia',
    ru: 'Либерия',
    uk: 'Ліберія',
    dial_code: '+231',
    emoji: '🇱🇷',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    en: 'Libya',
    pl: 'Libia',
    ru: 'Ливия',
    uk: 'Лівія',
    dial_code: '+218',
    emoji: '🇱🇾',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    en: 'Liechtenstein',
    pl: 'Liechtenstein',
    ru: 'Лихтенштейн',
    uk: 'Ліхтенштейн',
    dial_code: '+423',
    emoji: '🇱🇮',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    en: 'Lithuania',
    pl: 'Litwa',
    ru: 'Литва',
    uk: 'Литва',
    dial_code: '+370',
    emoji: '🇱🇹',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    en: 'Luxembourg',
    pl: 'Luksemburg',
    ru: 'Люксембург',
    uk: 'Люксембург',
    dial_code: '+352',
    emoji: '🇱🇺',
    code: 'LU',
  },
  {
    name: 'Macao',
    en: 'Macao',
    pl: 'Makau',
    ru: 'Макао',
    uk: 'Макао',
    dial_code: '+853',
    emoji: '🇲🇴',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    en: 'North Macedonia',
    pl: 'Macedonia Północna',
    ru: 'Северная Македония',
    uk: 'Північна Македонія',
    dial_code: '+389',
    emoji: '🇲🇰',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    en: 'Madagascar',
    pl: 'Madagaskar',
    ru: 'Мадагаскар',
    uk: 'Мадагаскар',
    dial_code: '+261',
    emoji: '🇲🇬',
    code: 'MG',
  },
  {
    name: 'Malawi',
    en: 'Malawi',
    pl: 'Malawi',
    ru: 'Малави',
    uk: 'Малаві',
    dial_code: '+265',
    emoji: '🇲🇼',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    en: 'Malaysia',
    pl: 'Malezja',
    ru: 'Малайзия',
    uk: 'Малайзія',
    dial_code: '+60',
    emoji: '🇲🇾',
    code: 'MY',
  },
  {
    name: 'Maldives',
    en: 'Maldives',
    pl: 'Malediwy',
    ru: 'Мальдивы',
    uk: 'Мальдіви',
    dial_code: '+960',
    emoji: '🇲🇻',
    code: 'MV',
  },
  {
    name: 'Mali',
    en: 'Mali',
    pl: 'Mali',
    ru: 'Мали',
    uk: 'Малі',
    dial_code: '+223',
    emoji: '🇲🇱',
    code: 'ML',
  },
  {
    name: 'Malta',
    en: 'Malta',
    pl: 'Malta',
    ru: 'Мальта',
    uk: 'Мальта',
    dial_code: '+356',
    emoji: '🇲🇹',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    en: 'Marshall Islands',
    pl: 'Wyspy Marshalla',
    ru: 'Маршалловы острова',
    uk: 'Маршаллові острови',
    dial_code: '+692',
    emoji: '🇲🇭',
    code: 'MH',
  },
  {
    name: 'Martinique',
    en: 'Martinique',
    pl: 'Martynika',
    ru: 'Мартиника',
    uk: 'Мартиніка',
    dial_code: '+596',
    emoji: '🇲🇶',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    en: 'Mauritania',
    pl: 'Mauretania',
    ru: 'Мавритания',
    uk: 'Мавританія',
    dial_code: '+222',
    emoji: '🇲🇷',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    en: 'Mauritius',
    pl: 'Mauritius',
    ru: 'Маврикий',
    uk: 'Маврикій',
    dial_code: '+230',
    emoji: '🇲🇺',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    en: 'Mayotte',
    pl: 'Majotta',
    ru: 'Майотта',
    uk: 'Майотта',
    dial_code: '+262',
    emoji: '🇾🇹',
    code: 'YT',
  },
  {
    name: 'Mexico',
    en: 'Mexico',
    pl: 'Meksyk',
    ru: 'Мексика',
    uk: 'Мексика',
    dial_code: '+52',
    emoji: '🇲🇽',
    code: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    en: 'Micronesia',
    pl: 'Mikronezja',
    ru: 'Микронезия',
    uk: 'Мікронезія',
    dial_code: '+691',
    emoji: '🇫🇲',
    code: 'FM',
  },
  {
    name: 'Moldova',
    en: 'Moldova',
    pl: 'Mołdawia',
    ru: 'Молдова',
    uk: 'Молдова',
    dial_code: '+373',
    emoji: '🇲🇩',
    code: 'MD',
  },
  {
    name: 'Monaco',
    en: 'Monaco',
    pl: 'Monako',
    ru: 'Монако',
    uk: 'Монако',
    dial_code: '+377',
    emoji: '🇲🇨',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    en: 'Mongolia',
    pl: 'Mongolia',
    ru: 'Монголия',
    uk: 'Монголія',
    dial_code: '+976',
    emoji: '🇲🇳',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    en: 'Montenegro',
    pl: 'Czarnogóra',
    ru: 'Черногория',
    uk: 'Чорногорія',
    dial_code: '+382',
    emoji: '🇲🇪',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    en: 'Montserrat',
    pl: 'Montserrat',
    ru: 'Монтсеррат',
    uk: 'Монтсеррат',
    dial_code: '+1664',
    emoji: '🇲🇸',
    code: 'MS',
  },
  {
    name: 'Morocco',
    en: 'Morocco',
    pl: 'Maroko',
    ru: 'Марокко',
    uk: 'Марокко',
    dial_code: '+212',
    emoji: '🇲🇦',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    en: 'Mozambique',
    pl: 'Mozambik',
    ru: 'Мозамбик',
    uk: 'Мозамбік',
    dial_code: '+258',
    emoji: '🇲🇿',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    en: 'Myanmar',
    pl: 'Mjanma',
    ru: 'Мьянма',
    uk: "М'янма",
    dial_code: '+95',
    emoji: '🇲🇲',
    code: 'MM',
  },
  {
    name: 'Namibia',
    en: 'Namibia',
    pl: 'Namibia',
    ru: 'Намибия',
    uk: 'Намібія',
    emoji: '🇳🇦',
    dial_code: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    en: 'Nauru',
    pl: 'Nauru',
    ru: 'Науру',
    uk: 'Науру',
    dial_code: '+674',
    emoji: '🇳🇷',
    code: 'NR',
  },
  {
    name: 'Nepal',
    en: 'Nepal',
    pl: 'Nepal',
    ru: 'Непал',
    uk: 'Непал',
    dial_code: '+977',
    emoji: '🇳🇵',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    en: 'Netherlands',
    pl: 'Holandia',
    ru: 'Нидерланды',
    uk: 'Нідерланди',
    dial_code: '+31',
    emoji: '🇳🇱',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    en: 'Netherlands Antilles',
    pl: 'Antyle Holenderskie',
    ru: 'Нидерландские Антилы',
    uk: 'Нідерландські Антили',
    dial_code: '+599',
    emoji: '🇧🇶',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    en: 'New Caledonia',
    pl: 'Nowa Kaledonia',
    ru: 'Новая Каледония',
    uk: 'Нова Каледонія',
    dial_code: '+687',
    emoji: '🇳🇨',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    en: 'New Zealand',
    pl: 'Nowa Zelandia',
    ru: 'Новая Зеландия',
    uk: 'Нова Зеландія',
    dial_code: '+64',
    emoji: '🇳🇿',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    en: 'Nicaragua',
    pl: 'Nikaragua',
    ru: 'Никарагуа',
    uk: 'Нікарагуа',
    dial_code: '+505',
    emoji: '🇳🇮',
    code: 'NI',
  },
  {
    name: 'Niger',
    en: 'Niger',
    pl: 'Niger',
    ru: 'Нигер',
    uk: 'Нігер',
    dial_code: '+227',
    emoji: '🇳🇪',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    en: 'Nigeria',
    pl: 'Nigeria',
    ru: 'Нигерия',
    uk: 'Нігерія',
    dial_code: '+234',
    emoji: '🇳🇬',
    code: 'NG',
  },
  {
    name: 'Niue',
    en: 'Niue',
    pl: 'Niue',
    ru: 'Ниуэ',
    uk: 'Ніуе',
    dial_code: '+683',
    emoji: '🇳🇺',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    en: 'Norfolk Island',
    pl: 'Wyspa Norfolk',
    ru: 'Остров Норфолк',
    uk: 'Острів Норфолк',
    dial_code: '+672',
    emoji: '🇳🇫',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    en: 'Northern Mariana Islands',
    pl: 'Mariany Północne',
    ru: 'Северные Марианские острова',
    uk: 'Північні Маріанські острови',
    dial_code: '+1670',
    emoji: '🇲🇵',
    code: 'MP',
  },
  {
    name: 'Norway',
    en: 'Norway',
    pl: 'Norwegia',
    ru: 'Норвегия',
    uk: 'Норвегія',
    dial_code: '+47',
    emoji: '🇳🇴',
    code: 'NO',
  },
  {
    name: 'Oman',
    en: 'Oman',
    pl: 'Oman',
    ru: 'Оман',
    uk: 'Оман',
    dial_code: '+968',
    emoji: '🇴🇲',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    en: 'Pakistan',
    pl: 'Pakistan',
    ru: 'Пакистан',
    uk: 'Пакистан',
    dial_code: '+92',
    emoji: '🇵🇰',
    code: 'PK',
  },
  {
    name: 'Palau',
    en: 'Palau',
    pl: 'Palau',
    ru: 'Палау',
    uk: 'Палау',
    dial_code: '+680',
    emoji: '🇵🇼',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    en: 'Palestine',
    pl: 'Palestyna',
    ru: 'Палестина',
    uk: 'Палестина',
    dial_code: '+970',
    emoji: '🇵🇸',
    code: 'PS',
  },
  {
    name: 'Panama',
    en: 'Panama',
    pl: 'Panama',
    ru: 'Панама',
    uk: 'Панама',
    dial_code: '+507',
    emoji: '🇵🇦',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    en: 'Papua New Guinea',
    pl: 'Papua-Nowa Gwinea',
    ru: 'Папуа — Новая Гвинея',
    uk: 'Папуа — Нова Гвінея',
    dial_code: '+675',
    emoji: '🇵🇬',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    en: 'Paraguay',
    pl: 'Paragwaj',
    ru: 'Парагвай',
    uk: 'Парагвай',
    dial_code: '+595',
    emoji: '🇵🇾',
    code: 'PY',
  },
  {
    name: 'Peru',
    en: 'Peru',
    pl: 'Peru',
    ru: 'Перу',
    uk: 'Перу',
    dial_code: '+51',
    emoji: '🇵🇪',
    code: 'PE',
  },
  {
    name: 'Philippines',
    en: 'Philippines',
    pl: 'Filipiny',
    ru: 'Филиппины',
    uk: 'Філіппіни',
    dial_code: '+63',
    emoji: '🇵🇭',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    en: 'Pitcairn',
    pl: 'Pitcairn',
    ru: 'Питкэрн',
    uk: 'Піткерн',
    dial_code: '+872',
    emoji: '🇵🇳',
    code: 'PN',
  },
  {
    name: 'Poland',
    en: 'Poland',
    pl: 'Polska',
    ru: 'Польша',
    uk: 'Польща',
    dial_code: '+48',
    emoji: '🇵🇱',
    code: 'PL',
  },
  {
    name: 'Portugal',
    en: 'Portugal',
    pl: 'Portugalia',
    ru: 'Португалия',
    uk: 'Португалія',
    dial_code: '+351',
    emoji: '🇵🇹',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    en: 'Puerto Rico',
    pl: 'Portoryko',
    ru: 'Пуэрто-Рико',
    uk: 'Пуерто-Ріко',
    dial_code: '+1939',
    emoji: '🇵🇷',
    code: 'PR',
  },
  {
    name: 'Qatar',
    en: 'Qatar',
    pl: 'Katar',
    ru: 'Катар',
    uk: 'Катар',
    dial_code: '+974',
    emoji: '🇶🇦',
    code: 'QA',
  },
  {
    name: 'Romania',
    en: 'Romania',
    pl: 'Rumunia',
    ru: 'Румыния',
    uk: 'Румунія',
    dial_code: '+40',
    emoji: '🇷🇴',
    code: 'RO',
  },
  {
    name: 'Russia',
    en: 'Russia',
    pl: 'Rosja',
    ru: 'Россия',
    uk: 'Росія',
    dial_code: '+7',
    emoji: '🇷🇺',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    en: 'Rwanda',
    pl: 'Rwanda',
    ru: 'Руанда',
    uk: 'Руанда',
    dial_code: '+250',
    emoji: '🇷🇼',
    code: 'RW',
  },
  {
    name: 'Reunion',
    en: 'Reunion',
    pl: 'Reunion',
    ru: 'Реюньон',
    uk: 'Реюньон',
    dial_code: '+262',
    emoji: '🇷🇪',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    en: 'Saint Barthelemy',
    pl: 'Saint-Barthélemy',
    ru: 'Сен-Бартелеми',
    uk: 'Сен-Бартелемі',
    dial_code: '+590',
    emoji: '🇧🇱',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    en: 'Saint Helena, Ascension and Tristan Da Cunha',
    pl: 'Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha',
    ru: 'Остров Святой Елены, Вознесения и Тристан-да-Кунья',
    uk: 'Острів Святої Єлени, Вознесіння і Тристан-да-Кунья',
    dial_code: '+290',
    emoji: '🇸🇭',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    en: 'Saint Kitts and Nevis',
    pl: 'Saint Kitts i Nevis',
    ru: 'Сент-Китс и Невис',
    uk: 'Сент-Кітс і Невіс',
    dial_code: '+1869',
    emoji: '🇰🇳',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    en: 'Saint Lucia',
    pl: 'Saint Lucia',
    ru: 'Сент-Люсия',
    uk: 'Сент-Люсія',
    dial_code: '+1758',
    emoji: '🇱🇨',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    en: 'Saint Martin',
    pl: 'Saint-Martin',
    ru: 'Сен-Мартен',
    uk: 'Сен-Мартен',
    dial_code: '+590',
    emoji: '🇲🇫',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    en: 'Saint Pierre and Miquelon',
    pl: 'Saint-Pierre i Miquelon',
    ru: 'Сен-Пьер и Микелон',
    uk: "Сен-П'єр і Мікелон",
    dial_code: '+508',
    emoji: '🇵🇲',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    en: 'Saint Vincent and the Grenadines',
    pl: 'Saint Vincent i Grenadyny',
    ru: 'Сент-Винсент и Гренадины',
    uk: 'Сент-Вінсент і Гренадини',
    dial_code: '+1784',
    emoji: '🇻🇨',
    code: 'VC',
  },
  {
    name: 'Samoa',
    en: 'Samoa',
    pl: 'Samoa',
    ru: 'Самоа',
    uk: 'Самоа',
    dial_code: '+685',
    emoji: '🇼🇸',
    code: 'WS',
  },
  {
    name: 'San Marino',
    en: 'San Marino',
    pl: 'San Marino',
    ru: 'Сан-Марино',
    uk: 'Сан-Марино',
    dial_code: '+378',
    emoji: '🇸🇲',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    en: 'Sao Tome and Principe',
    pl: 'Wyspy Świętego Tomasza i Książęca',
    ru: 'Сан-Томе и Принсипи',
    uk: 'Сан-Томе і Принсіпі',
    dial_code: '+239',
    emoji: '🇸🇹',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    en: 'Saudi Arabia',
    pl: 'Arabia Saudyjska',
    ru: 'Саудовская Аравия',
    uk: 'Саудівська Аравія',
    dial_code: '+966',
    emoji: '🇸🇦',
    code: 'SA',
  },
  {
    name: 'Senegal',
    en: 'Senegal',
    pl: 'Senegal',
    ru: 'Сенегал',
    uk: 'Сенегал',
    dial_code: '+221',
    emoji: '🇸🇳',
    code: 'SN',
  },
  {
    name: 'Serbia',
    en: 'Serbia',
    pl: 'Serbia',
    ru: 'Сербия',
    uk: 'Сербія',
    dial_code: '+381',
    emoji: '🇷🇸',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    en: 'Seychelles',
    pl: 'Seszele',
    ru: 'Сейшелы',
    uk: 'Сейшели',
    dial_code: '+248',
    emoji: '🇸🇨',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    en: 'Sierra Leone',
    pl: 'Sierra Leone',
    ru: 'Сьерра-Леоне',
    uk: 'Сьєрра-Леоне',
    dial_code: '+232',
    emoji: '🇸🇱',
    code: 'SL',
  },
  {
    name: 'Singapore',
    en: 'Singapore',
    pl: 'Singapur',
    ru: 'Сингапур',
    uk: 'Сінгапур',
    dial_code: '+65',
    emoji: '🇸🇬',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    en: 'Slovakia',
    pl: 'Słowacja',
    ru: 'Словакия',
    uk: 'Словаччина',
    dial_code: '+421',
    emoji: '🇸🇰',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    en: 'Slovenia',
    pl: 'Słowenia',
    ru: 'Словения',
    uk: 'Словенія',
    dial_code: '+386',
    emoji: '🇸🇮',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    en: 'Solomon Islands',
    pl: 'Wyspy Salomona',
    ru: 'Соломоновы острова',
    uk: 'Соломонові острови',
    dial_code: '+677',
    emoji: '🇸🇧',
    code: 'SB',
  },
  {
    name: 'Somalia',
    en: 'Somalia',
    pl: 'Somalia',
    ru: 'Сомали',
    uk: 'Сомалі',
    dial_code: '+252',
    emoji: '🇸🇴',
    code: 'SO',
  },
  {
    name: 'South Africa',
    en: 'South Africa',
    pl: 'Republika Południowej Afryki',
    ru: 'Южно-Африканская Республика',
    uk: 'Південно-Африканська Республіка',
    dial_code: '+27',
    emoji: '🇿🇦',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    en: 'South Sudan',
    pl: 'Sudan Południowy',
    ru: 'Южный Судан',
    uk: 'Південний Судан',
    dial_code: '+211',
    emoji: '🇸🇸',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    en: 'South Georgia and the South Sandwich Islands',
    pl: 'Georgia Południowa i Sandwich Południowy',
    ru: 'Южная Георгия и Южные Сандвичевы острова',
    uk: 'Південна Джорджія та Південні Сандвічеві острови',
    dial_code: '+500',
    emoji: '🇬🇸',
    code: 'GS',
  },
  {
    name: 'Spain',
    en: 'Spain',
    pl: 'Hiszpania',
    ru: 'Испания',
    uk: 'Іспанія',
    dial_code: '+34',
    emoji: '🇪🇸',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    en: 'Sri Lanka',
    pl: 'Sri Lanka',
    ru: 'Шри-Ланка',
    uk: 'Шрі-Ланка',
    dial_code: '+94',
    emoji: '🇱🇰',
    code: 'LK',
  },
  {
    name: 'Sudan',
    en: 'Sudan',
    pl: 'Sudan',
    ru: 'Судан',
    uk: 'Судан',
    dial_code: '+249',
    emoji: '🇸🇩',
    code: 'SD',
  },
  {
    name: 'Suriname',
    en: 'Suriname',
    pl: 'Surinam',
    ru: 'Суринам',
    uk: 'Суринам',
    dial_code: '+597',
    emoji: '🇸🇷',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    en: 'Svalbard and Jan Mayen',
    pl: 'Svalbard i Jan Mayen',
    ru: 'Шпицберген и Ян-Майен',
    uk: 'Шпіцберген і Ян-Майєн',
    dial_code: '+47',
    emoji: '🇸🇯',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    en: 'Eswatini',
    pl: 'Eswatini',
    ru: 'Эсватини',
    uk: 'Есватіні',
    dial_code: '+268',
    emoji: '🇸🇿',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    en: 'Sweden',
    pl: 'Szwecja',
    ru: 'Швеция',
    uk: 'Швеція',
    dial_code: '+46',
    emoji: '🇸🇪',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    en: 'Switzerland',
    pl: 'Szwajcaria',
    ru: 'Швейцария',
    uk: 'Швейцарія',
    dial_code: '+41',
    emoji: '🇨🇭',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    en: 'Syria',
    pl: 'Syria',
    ru: 'Сирия',
    uk: 'Сирія',
    dial_code: '+963',
    emoji: '🇸🇾',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    en: 'Taiwan',
    pl: 'Tajwan',
    ru: 'Тайвань',
    uk: 'Тайвань',
    dial_code: '+886',
    emoji: '🇹🇼',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    en: 'Tajikistan',
    pl: 'Tadżykistan',
    ru: 'Таджикистан',
    uk: 'Таджикистан',
    dial_code: '+992',
    emoji: '🇹🇯',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    en: 'Tanzania',
    pl: 'Tanzania',
    ru: 'Танзания',
    uk: 'Танзанія',
    dial_code: '+255',
    emoji: '🇹🇿',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    en: 'Thailand',
    pl: 'Tajlandia',
    ru: 'Таиланд',
    uk: 'Таїланд',
    dial_code: '+66',
    emoji: '🇹🇭',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    en: 'Timor-Leste',
    pl: 'Timor Wschodni',
    ru: 'Восточный Тимор',
    uk: 'Східний Тимор',
    dial_code: '+670',
    emoji: '🇹🇱',
    code: 'TL',
  },
  {
    name: 'Togo',
    en: 'Togo',
    pl: 'Togo',
    ru: 'Того',
    uk: 'Того',
    dial_code: '+228',
    emoji: '🇹🇬',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    en: 'Tokelau',
    pl: 'Tokelau',
    ru: 'Токелау',
    uk: 'Токелау',
    dial_code: '+690',
    emoji: '🇹🇰',
    code: 'TK',
  },
  {
    name: 'Tonga',
    en: 'Tonga',
    pl: 'Tonga',
    ru: 'Тонга',
    uk: 'Тонга',
    dial_code: '+676',
    emoji: '🇹🇴',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    en: 'Trinidad and Tobago',
    pl: 'Trynidad i Tobago',
    ru: 'Тринидад и Тобаго',
    uk: 'Тринідад і Тобаго',
    dial_code: '+1868',
    emoji: '🇹🇹',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    en: 'Tunisia',
    pl: 'Tunezja',
    ru: 'Тунис',
    uk: 'Туніс',
    dial_code: '+216',
    emoji: '🇹🇳',
    code: 'TN',
  },
  {
    name: 'Turkey',
    en: 'Turkey',
    pl: 'Turcja',
    ru: 'Турция',
    uk: 'Туреччина',
    dial_code: '+90',
    emoji: '🇹🇷',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    en: 'Turkmenistan',
    pl: 'Turkmenistan',
    ru: 'Туркменистан',
    uk: 'Туркменістан',
    dial_code: '+993',
    emoji: '🇹🇲',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    en: 'Turks and Caicos Islands',
    pl: 'Turks i Caicos',
    ru: 'Теркс и Кайкос',
    uk: 'Теркс і Кайкос',
    dial_code: '+1649',
    emoji: '🇹🇨',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    en: 'Tuvalu',
    pl: 'Tuvalu',
    ru: 'Тувалу',
    uk: 'Тувалу',
    dial_code: '+688',
    emoji: '🇹🇻',
    code: 'TV',
  },
  {
    name: 'Uganda',
    en: 'Uganda',
    pl: 'Uganda',
    ru: 'Уганда',
    uk: 'Уганда',
    dial_code: '+256',
    emoji: '🇺🇬',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    en: 'Ukraine',
    pl: 'Ukraina',
    ru: 'Украина',
    uk: 'Україна',
    dial_code: '+380',
    emoji: '🇺🇦',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    en: 'United Arab Emirates',
    pl: 'Zjednoczone Emiraty Arabskie',
    ru: 'Объединенные Арабские Эмираты',
    uk: "Об'єднані Арабські Емірати",
    dial_code: '+971',
    emoji: '🇦🇪',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    en: 'United Kingdom',
    pl: 'Wielka Brytania',
    ru: 'Великобритания',
    uk: 'Великобританія',
    dial_code: '+44',
    emoji: '🇬🇧',
    code: 'GB',
  },
  {
    name: 'United States',
    en: 'United States',
    pl: 'Stany Zjednoczone',
    ru: 'Соединенные Штаты',
    uk: 'Сполучені Штати',
    dial_code: '+1',
    emoji: '🇺🇸',
    code: 'US',
  },
  {
    name: 'Uruguay',
    en: 'Uruguay',
    pl: 'Urugwaj',
    ru: 'Уругвай',
    uk: 'Уругвай',
    dial_code: '+598',
    emoji: '🇺🇾',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    en: 'Uzbekistan',
    pl: 'Uzbekistan',
    ru: 'Узбекистан',
    uk: 'Узбекистан',
    dial_code: '+998',
    emoji: '🇺🇿',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    en: 'Vanuatu',
    pl: 'Vanuatu',
    ru: 'Вануату',
    uk: 'Вануату',
    dial_code: '+678',
    emoji: '🇻🇺',
    code: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    en: 'Venezuela',
    pl: 'Wenezuela',
    ru: 'Венесуэла',
    uk: 'Венесуела',
    dial_code: '+58',
    emoji: '🇻🇪',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    en: 'Vietnam',
    pl: 'Wietnam',
    ru: 'Вьетнам',
    uk: "В'єтнам",
    dial_code: '+84',
    emoji: '🇻🇳',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    en: 'British Virgin Islands',
    pl: 'Brytyjskie Wyspy Dziewicze',
    ru: 'Британские Виргинские острова',
    uk: 'Британські Віргінські острови',
    dial_code: '+1284',
    emoji: '🇻🇬',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    en: 'U.S. Virgin Islands',
    pl: 'Wyspy Dziewicze Stanów Zjednoczonych',
    ru: 'Виргинские острова США',
    uk: 'Віргінські острови США',
    dial_code: '+1340',
    emoji: '🇻🇮',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    en: 'Wallis and Futuna',
    pl: 'Wallis i Futuna',
    ru: 'Уоллис и Футуна',
    uk: 'Уолліс і Футуна',
    dial_code: '+681',
    emoji: '🇼🇫',
    code: 'WF',
  },
  {
    name: 'Yemen',
    en: 'Yemen',
    pl: 'Jemen',
    ru: 'Йемен',
    uk: 'Ємен',
    dial_code: '+967',
    emoji: '🇾🇪',
    code: 'YE',
  },
  {
    name: 'Zambia',
    en: 'Zambia',
    pl: 'Zambia',
    ru: 'Замбия',
    uk: 'Замбія',
    dial_code: '+260',
    emoji: '🇿🇲',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    en: 'Zimbabwe',
    pl: 'Zimbabwe',
    ru: 'Зимбабве',
    uk: 'Зімбабве',
    dial_code: '+263',
    emoji: '🇿🇼',
    code: 'ZW',
  },
];

export const CountryPhoneCodesSortedUniq = Countries.sort(
  (a, b) => +a.dial_code - +b.dial_code,
).filter((v, i, a) => a.findIndex((t) => t.dial_code === v.dial_code) === i);

export const CountryCodes = Countries.map((country) => ({
  label: country.code,
  value: country.code,
})).sort((a, b) => a.value.localeCompare(b.value));

export const PhoneCodes = CountryPhoneCodesSortedUniq.map((country) => ({
  label: country.dial_code,
  value: country.dial_code,
})).sort((a, b) => {
  const aCode = parseInt(a.value.replace(/\D/g, ''));
  const bCode = parseInt(b.value.replace(/\D/g, ''));
  return aCode - bCode;
});

export const getCountryNames = (language: 'pl' | 'ru' | 'uk' | 'en') =>
  Countries.map((country) => ({
    label: country[language],
    value: country.name,
  })).sort((a, b) => a.label.localeCompare(b.label));
